/** Сутки в миллисекундах: цены старше этого срока экран называет отдельно. */
export const DAY_MS = 24 * 60 * 60 * 1000

/** Чем заменяется пустое наименование товара в списке и на ценнике. */
export const EMPTY_NAME_TEXT = '—'

/** Что показано вместо цены, когда у товара нет цены выбранного склада. */
export const NO_PRICE_TEXT = 'нет цены склада'

/** Высота этикетки макета в миллиметрах (30×20): от неё считается масштаб `--k` крупных ценников. */
export const BASE_LABEL_HEIGHT_MM = 20
